import { HttpErrorResponse } from "@angular/common/http";

export interface IUserAddMessagesHelper {
  title: string;
  description: string;
}

export class UserAddMessagesHelper {
  private readonly DEFAULT_ERROR: IUserAddMessagesHelper = {
    title: "Não foi possível criar o usuário.",
    description:
      "Estamos trabalhando para resolver esse problema. Por favor, tente novamente mais tarde e, se o erro persistir, entre em contato com a nossa equipe de atendimento.",
  };

  public status = 0;
  public errorObj: { code: string; description: string };

  public descriptions: any = {
    403: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "32": {
        title: "Esse e-mail não pode ser utilizado.",
        description:
          "Esse e-mail é de domínio público e não pode ser utilizado nesse cadastro. Por favor, utilize seu e-mail corporativo.",
      },
    },
    422: {
      default: {
        ...this.DEFAULT_ERROR,
      },
      "37": {
        title: "Não foi possível criar o usuário.",
        description:
          "Você atingiu a quantidade máxima de usuários desse contrato, entre em contato com a nossa equipe de atendimento.",
      },
    },
  };

  constructor(error: HttpErrorResponse) {
    this.status = error.status;
    this.errorObj = error?.error[0];
  }

  get error(): IUserAddMessagesHelper {
    const descriptionObj = this.descriptions[this.status];
    const code = this.errorObj?.code;
    return descriptionObj && descriptionObj[code]
      ? descriptionObj[code]
      : this.DEFAULT_ERROR;
  }
}
